<template>
    <div>
        <button class="btn btn-secondary" @click="showFilters = !showFilters"><i class="fa fa-filter"></i> {{transEdit('filter')}}</button>
        
        <div class="row " v-if="showFilters">
            <p class="text-muted pt-2">{{transEdit('booking-filter-text')}}</p>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{transEdit('locations')}}</label>
                    <multiselect
                            v-model="selectedLocations"
                            :options="filterLocations"
                            track-by="address"
                            label="address"
                            :showLabels="false"
                            :hideSelected="true"
                            placeholder="Välj lokal"
                            selectLabel=""
                            deselectLabel=""
                            :multiple="true">
                    </multiselect>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{transEdit('therapists')}}</label>
                    <multiselect
                            v-model="selectedTherapists"
                            :options="filterTherapists"
                            track-by="name"
                            label="name"
                            :showLabels="false"
                            :hideSelected="true"
                            placeholder="Välj terapeut"
                            selectLabel=""
                            deselectLabel=""
                            :multiple="true">
                    </multiselect>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{transEdit('treatments')}}</label>
                    <multiselect
                            v-model="selectedTreatments"
                            :options="filterTreatments"
                            track-by="name"
                            label="name"
                            :showLabels="false"
                            :hideSelected="true"
                            placeholder="Välj behandling"
                            selectLabel=""
                            deselectLabel=""
                            :multiple="true">
                    </multiselect>
                </div>
            </div>
        </div>
        <flash></flash>



        <div class="row">
            <div class="col-lg-12 calendar-on-light-background">
                <calendar
                        ref="calendar"
                        :ajax-url="ajaxUrl"
                        :date-key="'start'"
                        @daySelected="setDate"
                ></calendar>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 d-flex flex-column">
                <h4 v-if="date" class="mt-4 mt-lg-2 text-xl text-center">{{date.date.format('YYYY-MM-DD')}}</h4>
                <div v-if="date" class="schedule-list">
                    <div v-for="schedule in date.events" class="border mt-2 mb-2 p-2 schedule-slot rounded flex">
                        <div class="w-3/4">
                            <div class="h6 font-weight-bold text-lg">{{getTime(schedule.start)}} - {{getTime(schedule.end)}}</div>
                            <div class="text-muted">{{schedule.location.address}}  {{schedule.location.city ? schedule.location.city.name : ''}}</div>
                            <div class="text-muted">{{getTreatmentString(schedule)}}</div>
                            
                        </div>
                        <div v-if="schedule.booking" class="schedule-slot-customer w-1/4">
                            <div class="text-lg text-red-600">{{transEdit('booked')}}</div>
                            <div class="">{{schedule.booking.user.name}}</div>
                            <div class="">{{getDateTime(schedule.booking.created_at)}}</div>

                        </div>
                    </div>
                </div>
                <div v-else class="d-flex justify-content-center align-content-center">
                    <div class="h4 text-black-50 mt-4 mt-lg-0 text-center text-lg">
                        {{transEdit('choose-day')}}
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "CompanyOfficialDash",
        props: ['official', 'therapists', 'treatments', 'locations', 'company', 'route_reporting'],
        data() {
            return {
                date: null,
                selectedSchedule: null,
                selectedLocations: [],
                selectedTherapists: [],
                selectedTreatments: [],
                showFilters: false,
            }
        },
        computed: {
            ajaxUrl(){
                let first = true;
                let url = '/official/filterevents';

                let symbol = '?';

                this.selectedLocations.forEach((location) => {
                    url += symbol+'location_ids[]='+location.id;
                    if(first){
                        symbol = '&';
                        first = false;
                    }
                });

                this.selectedTherapists.forEach((therapist) => {
                    url += symbol+'therapist_ids[]='+therapist.id;
                    if(first){
                        symbol = '&';
                        first = false;
                    }
                });

                this.selectedTreatments.forEach((treatment) => {
                    url += symbol+'treatment_ids[]='+treatment.id;
                    if(first){
                        symbol = '&';
                        first = false;
                    }
                });

                url += symbol+'company_id='+this.official.company.id;

                return url;
            },
            filterLocations() {
                let simplifiedLocations = [];
                if(this.locations){
                    this.locations.forEach((location) => {
                        let tempAddressString = location.city.name + ', ' + location.address;

                        simplifiedLocations.push({
                            id: location.id,
                            address:  tempAddressString,
                        });
                    });
                }

                return simplifiedLocations;
            },
            filterTherapists() {
                let simplifiedTherapists = [];
                if(this.therapists){
                    this.therapists.forEach((therapist) => {
                        simplifiedTherapists.push({
                            id: therapist.id,
                            name: therapist.user.name,
                        });
                    });
                }
                return simplifiedTherapists;
            },
            filterTreatments() {
                let simplifiedTreatments = [];
                if(this.treatments){
                    this.treatments.forEach((treatment) => {
                        simplifiedTreatments.push({
                            id: treatment.id,
                            name: treatment.name,
                        });
                    });
                }
                return simplifiedTreatments;
            },
        },
        methods: {
            setDate(date){
                this.date = date;
            },
            getDateTime(dateString){
                return moment(dateString).format('YYYY-MM-DD HH:mm')
            },
            getTime(dateString){
                return moment(dateString).format('HH:mm')
            },
            getTreatmentString(schedule){
                if (schedule.booking) {
                    return schedule.booking.treatment.name;
                }
                if(schedule.treatments.length > 1){
                    return schedule.treatments.length + ' ' + this.transEdit('treatments').toLowerCase();
                }

                return schedule.treatments[0].name;
            }
        },

        mounted() {

        }
    }
</script>

<style scoped>
   
</style>
